import { E2eeReceiver } from 'features/e2ee/E2eeReceiver';
import { base64Decrypt } from 'features/e2ee/utils/base64Decrypt';
import { store } from 'store/store';
import { remoteStreamSecretDecrypted } from 'features/e2ee/actions';
import type { DecryptionStrategy } from 'features/e2ee/core/decryption-strategies';
import type { EncryptedData } from 'features/e2ee/types';

export class StreamKeyDecryption implements DecryptionStrategy {
  canHandle(data: EncryptedData): boolean {
    return !!data.streamKey;
  }

  async decrypt(data: EncryptedData, receiver: E2eeReceiver): Promise<void> {
    if (!receiver.sharedSecret) {
      throw new Error('Cannot decrypt stream key. Shared secret is not defined');
    }

    const streamKey = await base64Decrypt(data.streamKey!, receiver.sharedSecret);

    receiver.setStreamKey(streamKey);

    store.dispatch(
      remoteStreamSecretDecrypted({
        userId: receiver.id,
        roomId: receiver.roomId,
      })
    );
  }
}
